"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attachmentCreateApi = attachmentCreateApi;
exports.attachmentDeleteApi = attachmentDeleteApi;
exports.attachmentListApi = attachmentListApi;
exports.attachmentUpdateApi = attachmentUpdateApi;
exports.categoryApi = categoryApi;
exports.formatLstApi = formatLstApi;
exports.picDeleteApi = picDeleteApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * @description 附件分类 -- 所有分类
 */
function formatLstApi(data) {
  return _request.default.get({
    url: '/admin/product/save',
    method: 'POST',
    data: data
  });
}
/**
 * @description 附件分类 -- 添加分类
 */
function attachmentCreateApi() {
  return _request.default.get("system/attachment/category/create/form");
}
/**
 * @description 附件分类 -- 编辑分类
 */
function attachmentUpdateApi(id) {
  return _request.default.get("system/attachment/category/update/form/".concat(id));
}
/**
 * @description 附件分类 -- 删除分类
 */
function attachmentDeleteApi(id) {
  return _request.default.delete("system/attachment/category/delete/".concat(id));
}
/**
 * @description 图片列表
 */
function attachmentListApi(data) {
  return _request.default.get("system/attachment/lst", data);
}
/**
 * @description 图片列表 -- 删除
 */
function picDeleteApi(id) {
  return _request.default.delete("system/attachment/delete", id);
}
/**
 * @description 图片列表 -- 修改附件分类
 */
function categoryApi(ids, attachment_category_id) {
  return _request.default.post("system/attachment/category", {
    ids: ids,
    attachment_category_id: attachment_category_id
  });
}